module.exports = __webpack_public_path__ + "img/complete@3x.0aecedde.png";